export default {
  default: () => import("/builds/racent/frontend/website_nicsrs/layouts/default.vue").then(m => m.default || m)
}